export default "__VITE_ASSET__BVL3KBej__"